import React from 'react';
import './login.css';
import BETO from '../../img/beto.jpg';
import LOGO from '../../img/foco90.svg';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import WS from '../../config/Ws';
import {WS_PAGAMENTO} from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Modal from '../../components/modal.v2/Modal';
import EsqueceuSenha from './EsqueceuSenha';
import Pagamento from '../pagamento/Pagamento';
import Beto from '../../img/betoIntro.png';
import Cadastro from '../cadastro/Cadastro';

import PASSO1 from '../../img/tutorial-01.jpg';
import PASSO2 from '../../img/tutorial-02.jpg';
import PASSO3 from '../../img/tutorial-03.jpg';
import PASSO4 from '../../img/tutorial-04.jpg';

const URL_LOGIN = WS.login;
const URL_LOGGED = WS.checkLogged;


class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false,
      email: '',
      senha: '',
      statusTutorial: true
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openEsqueceuSenha = this.openEsqueceuSenha.bind(this);
    this.openPagamento = this.openPagamento.bind(this);
    this.signin = this.signin.bind(this);
    this.removeTutorial = this.removeTutorial.bind(this);
  }

  componentDidMount(){
    const self = this;
    var usuario = window.localStorage.getItem('usuario');
    var senha = window.localStorage.getItem('senha');

    if(usuario && senha){
      this.setState({
        email: usuario,
        senha: senha,
        statusTutorial: false
      });
      this.makeLogin({email: usuario, senha: senha});
    }

    /*Requisitions({
      url: URL_LOGGED,
      data: {},
      sucess:function(data){
        if(data.status){
          window.dadosUser = data.user;
          self.props.history.push('/area-restrita/meu-treino/');
        }
      },
      error:function(data){
      }
    });*/
  }

  signin(e){
    e.preventDefault();

    Modal.create({
      content: <Cadastro
      history={this.props.history} />
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const usuario = this.state.email;
    const senha = this.state.senha;

    this.makeLogin({email: usuario, senha: senha});
  }

  openPagamento(){
    Dialog.destroy();

    const usuario = this.state.email;
    const senha = this.state.senha;

    const data = {email: usuario, senha: senha};

    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      usuarioSenha,
      erroLogar,
      erroPlanos
    }
    = this.state.strings;

    const self = this;

    Requisitions({
      url: WS_PAGAMENTO.login,
      data: data,
      sucess:function(data){
        if(data.status){
          if(!data.planos){
            var msg = {
              title: atencao,
              text: erroPlanos
            };
            Dialog.create(msg);
            return false;
          }

          Login.setDataUser({usuario,senha,user:data.user});

          Modal.create({
            content: <Pagamento
            data={data}
            history={self.props.history} />
          });
        }else{
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroLogar
        });
      }
    });
  }

  openEsqueceuSenha(e){
    e.preventDefault();

    Modal.create({
      content: <EsqueceuSenha />
    });
  }

  static setDataUser(args){
    window.localStorage.setItem('usuario', args.usuario);
    window.localStorage.setItem('senha', args.senha);
    window.localStorage.setItem('dadosUser', JSON.stringify(args.user));
    window.dadosUser = args.user;
  }

  makeLogin(args){
    const data = args;
    const usuario = args.email;
    const senha = args.senha;

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      usuarioSenha,
      erroLogar
    }
    = this.state.strings;

    if(!usuario && !senha){
      var msg = {
        title: atencao,
        text: usuarioSenha
      };

      Dialog.create(msg);
      return false;
    }else{

      Requisitions({
        url:URL_LOGIN,
        data: data,
        sucess:function(data){
          if(data.status){
            Login.setDataUser({usuario,senha,user:data.user});
            self.props.history.push('/area-restrita/meu-treino/');
          }else{
            if(data.expired){

              var msg = {
                title: atencao,
                text: data.msg,
                type: Dialog.CONFIRM,
                txtCancel: 'Fechar',
                txtOk: 'Assinar',
                onSubmit: self.openPagamento
              };

              Dialog.create(msg);

            }else{
              var msg = {
                title: atencao,
                text: data.msg
              };
              Dialog.create(msg);
            }
          }
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroLogar
          });
        }
      });
    }
  }

  getTutorial(){
    return (
      <div className='tutorial'>
        <div className='tutorial__wrapper'>
          <div className='tutorial__inner'>
            <div className='tutorial__box'>
              <a href='#' onClick={this.removeTutorial}  className='bt-close-tutorial'><i className="fas fa-times"></i></a>
              <div className="box-login-logo"><img src={LOGO} /></div>
              <p className='tutorial__title'>Como instalar o app Foco90 no seu iPhone</p>
              <div className='tutorial__passo'>
                <img src={PASSO1} />
                <strong>Passo 1</strong>
                <p>Abra o <span className='strong'>Safari</span> no seu iphone e clique no ícone mostrado logo acima</p>
              </div>

              <div className='tutorial__passo'>
                <img src={PASSO2} />
                <strong>Passo 2</strong>
                <p>Deslize os botões até encontrar o botão <span className='strong'>Tela de início</span> ou <span className='strong'>Add to Home Screen</span></p>
              </div>

              <div className='tutorial__passo'>
                <img src={PASSO3} />
                <strong>Passo 3</strong>
                <p>Toque em <span className='strong'>Adicionar</span> ou <span className='strong'>Add</span></p>
              </div>

              <div className='tutorial__passo'>
                <img src={PASSO4} />
                <strong>Passo 4</strong>
                <p>Pronto, agora você tem o seu app <span className='strong'>Foco90</span> instalado</p>
              </div>
              <div className='tutorial__box-button'><Button onClick={this.removeTutorial} type="button" text="Fechar" classes="button-login simple-button" /></div>

            </div>


          </div>
        </div>
      </div>
    );
  }

  removeTutorial(e){
    this.setState({
      statusTutorial: false
    });
    e.preventDefault();
  }

  render() {
    let tutorial = this.state.statusTutorial ? this.getTutorial() : null;
    const url = window.location.href;
    //se tiver ?ios=true na url apresentamos o tutorial ao usuário
    tutorial = (url.indexOf("?ios=true") > -1) ? tutorial : null;

    return (
      <div className="page-login" >
        {tutorial}
        <div className="wrapper-login">
          <div className="">
              <div className="box-form-login">
                <div className="box-login">
                  <div className="box-login--inner">
                    <div className="box-login-logo"><img src={LOGO} /></div>
                    <br /><br />
                    {/*<div className='img-beto-login'><img src={Beto} /></div>*/}
                    <form className="form-login"  onSubmit={this.handleSubmit}>
                      <TextInput onChange={this.handleInputChange} name="email" title="Email" placeholder="Digite o email"></TextInput>
                      <TextInput onChange={this.handleInputChange} name="senha" type="password" title="Senha" placeholder="Digite a senha"></TextInput>
                      <div className="box-center-button"><br />
                        <div><Button type="submit" text="Entrar" classes="button-outline simple-button" /></div>
                        <br />
                        <div><Button onClick={this.signin} type="button" text="Testar grátis" classes="button-login simple-button bounce" /></div>
                        <div><br />
                          <a href='#' className='bt-not-signedin' onClick={this.openEsqueceuSenha}>Esqueceu sua senha?</a>
                        </div>
                    </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className=" beto-img-login">
                <img className="img-beto" src={BETO} />
              </div>
              <div className='clear'></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/classes/login/Login.js